<script>
    import axios from 'axios';
    import mixin from '../../mixin';

    export default {
        mixins: [mixin],
        props: {
            idFromUrl: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                rentalInformationData: {},
            };
        },
        async mounted() {
            await this.fetchData(this.idFromUrl);
        },
        methods: {
            async fetchData(idFromURL) {
                try {
                    const response = await axios.get(
                        `/api/dossiers/${idFromURL}/huurobjecten`
                    );
                    if (response ?? response.data) {
                        this.rentalInformationData = response.data;
                    } else {
                        console.error('Invalid data received:', response);
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            },
        },
    };
</script>

<template>
    <div class="rental-information mt-3 pt-3 content">
        <template v-if="rentalInformationData">
            <div class="columns">
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationLocation') }}</p>
                        <p>{{ checkValue(rentalInformationData.locatie) }}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationTypeOfLivingSpace') }}</p>
                        <p>{{ checkValue(rentalInformationData.soortwoonruimte) }}</p>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationContractNumber') }}</p>
                        <p>{{ checkValue(rentalInformationData.contractnummer) }}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationRentalStatus') }}</p>
                        <p>{{ checkValue(rentalInformationData.huurstatus) }}</p>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationStartOfContract') }}</p>
                        <p>{{ checkValue(toDateStr(rentalInformationData.aanvangcontract)) }}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationEndOfContract') }}</p>
                        <p>{{ checkValue(toDateStr(rentalInformationData.einddatumcontract)) }}</p>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationRentalPeriod') }}</p>
                        <p>{{ checkValue(rentalInformationData.huurperiode) }}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationReasonEnding') }}</p>
                        <p>{{ checkValue(rentalInformationData.redeneinde) }}</p>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationRentalEntrance') }}</p>
                        <p>{{ checkValue(toDateStr(rentalInformationData.inganghuurcontract)) }}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationAddedTo') }}</p>
                        <p>{{ checkValue(toDateStr(rentalInformationData.bijgeboekttot)) }}</p>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationBasicRent') }}</p>
                        <p>{{ checkValue(toEuro(rentalInformationData.kalehuur, true)) }}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationGrossRent') }}</p>
                        <p>{{ checkValue(toEuro(rentalInformationData.brutohuur, true)) }}</p>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationHeatingCosts') }}</p>
                        <p>{{ checkValue(toEuro(rentalInformationData.stookkosten, true)) }}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationServiceCharge') }}</p>
                        <p>{{ checkValue(toEuro(rentalInformationData.servicekosten, true)) }}</p>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationIncreasePeriodically') }}</p>
                        <p>{{ checkValue(rentalInformationData.periodeverhogen) }}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="rental-information__item">
                        <p>{{ $store.getters.getRightText('dossierdetailLabelRentalInformationCollectionCostsInstallments') }}</p>
                        <p>{{ checkValue(rentalInformationData.incassokosten) }}</p>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="box">
                {{ $store.getters.getRightText('dossierdetailLabelNoResults') }}
            </div>
        </template>
    </div>
</template>
